/** 
 * Resolve path to not be relative
 * @param path - Path to resolve
 * @returns Absolute path
 */
export function resolvePath(path: string): string {
  if (!path) return;
  // if (window.location.hostname === 'localhost' || window.location.hostname.includes('192.168')) {
  //   return path;
  // }

  let origin = process.env.VUE_APP_WEBSITE_URL;
  const url = window.location.origin;

  if (
    url.includes('localhost') || 
    url.includes('192.168') ||
    url.includes('develop') ||
    url.includes('staging') ||
    url.includes('production')
  ) {
    origin = window.location.origin + '/';
  }

  if((path as any).default) {
    (path as any).default = origin + (path as any).default;
    return path;
  }

  return origin + path;
}